let csrf = window._csrf || window.csrf
let waitForLogin
let isLoading = []
import toaster from "./toaster-store.js"
import { writable } from 'svelte/store'

export let netcount = writable(0) // number of network requests

const updateCSRF = ()=>{
  let csrfcookie = document.cookie.match(/_csrf=([^ ;]+)/)
  if(csrfcookie && csrfcookie.length > 0) csrf = csrfcookie[1]  
}

const showError = (res,json)=>{
  let title = res.status < 500 ? "Sorry..." : "Error!"
  let type = res.status < 500 ? "warning" : "danger"
  let message = json.message || "Unknown Error"
  toaster.add({type,title,message})
}

export const load = async ({url})=>{
  netcount.update(n => n + 1)
  let res,json
  try{
    res = await fetch(url)
    json = await res.json()
    updateCSRF()
  }catch(e){
    throw new Error(e.message)
  }finally{
    netcount.update(n => n - 1)
  }
  if (res.ok){
    return {data:json.data}
  }
  if (res.status == 401 && waitForLogin){
    await waitForLogin() // show login
    return load({url}) // try again
  }
  if(url!="/duocms/api/login") showError(res,json)
  throw new Error(json.message); 
}

export const save = async ({url,data, method})=>{
  try{
    if (!method){
      method = data.id ? "PUT" : "POST"
      url += data.id ? `/${data.id}` : ""
    }
    let res = await fetch(url ,{
      headers: {'content-type': 'application/json','X-CSRF-Token':csrf},
      credentials: 'same-origin',
      method: method,
      body: JSON.stringify(data)
    })
    updateCSRF()
    let json = await res.json();
    if (res.ok) return {data:json.data}
    if (res.status == 401 && waitForLogin){
      await waitForLogin() // show login
      return save(url,data) // try again
    }
    showError(res,json)
    throw new Error(json.message);
  }catch(err){
    console.log("api.save error",err)
  }
}

export const remove = async ({url})=>{
  let res = await fetch(url,{
    headers: new Headers({'content-type': 'application/json','X-CSRF-Token':csrf}),
    credentials: 'same-origin',
    method: "DELETE"
  })
  let json = await res.json();
  if (res.ok) return {data:json.data}
  if (res.status == 401 && waitForLogin){
    await waitForLogin() // show login
    console.log("retry",url)
    return load(url) // try again
  }
  showError(res,json)
  throw new Error(json.message); 
}

export const upload = async ({url,file,path,name})=>{
  let formData = new FormData()
  let res,json
  formData.append("_csrf", csrf)
  formData.append("path", path)
  formData.append("name", name ? name : file.name)
  formData.append('file', file)
  netcount.update(n => n + 1)
  try{
    res = await fetch(url, { method: 'POST', body: formData })
    json = await res.json()
  }catch(e){
    throw new Error(e.message)
  }finally{
    netcount.update(n => n - 1)
  }
  if (res.ok) return {data:json.data}
  if (res.status == 401 && waitForLogin){
    await waitForLogin() // show login
    return upload({url,file,path,name}) // try again
  }
  if(url!="/duocms/api/login") showError(res,json)
  throw new Error(json.message); 
}

export const registerLogin = (cback)=> waitForLogin = cback

export default {load,save,remove,registerLogin,netcount,upload}